import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Loader from "../../../../components/Loader";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import {
  NOTIFICATION_MESSAGE,
  VALIDATION_MSG,
} from "../../../../utils/constant";
import { createInternalDisbursement } from "../../../../thunks/DisPrice";

const CreateDisbursement = ({
  open,
  handleClose,
  getDisbursement = () => {},
}) => {
  const dispatch = useDispatch();
  const [isLoader, setLoader] = useState(false);
  const [isError, setIsError] = useState(false);
  const [disbursementData, setDisbursementData] = useState({
    name: "",
    isActive: true,
    isDeleted: false,
  });

  const handleChangeFormFields = (value, key) => {
    setDisbursementData({ ...disbursementData, [key]: value });
  };

  const handleCreateDisbursement = async () => {
    try {
      if (!disbursementData?.name) {
        setIsError(true);
        return;
      }
      setLoader(true);
      const payload = {
        name: disbursementData?.name,
        isActive: disbursementData?.isActive,
        isDeleted: disbursementData?.isDeleted,
      };
      const response = await dispatch(
        createInternalDisbursement(payload)
      ).unwrap();
      if (response) {
        setLoader(false);
        dispatch(
          showSnackbar({
            show: true,
            message: NOTIFICATION_MESSAGE?.INTERNAL_DISBURSEMENT_CREATE_SUCCESS,
            severity: "success",
          })
        );
        handleClose();
        await getDisbursement();
      } else {
        setLoader(false);
        setDisbursementData({
          name: "",
          isActive: true,
          isDeleted: false,
        });
        handleClose();
      }
    } catch (error) {
      handleClose();
      setDisbursementData({
        name: "",
        isActive: true,
        isDeleted: false,
      });
      dispatch(
        showSnackbar({
          show: true,
          message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"sm"}
        PaperProps={{ sx: { borderRadius: "28px", paddingBottom: 0 } }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        {/* Loader Component */}
        {isLoader && <Loader />}
        <DialogContent>
          <Grid container spacing={3}>
            {/* Create Task Label Section */}
            <Grid item xs={12}>
              <Typography
                className="serif_display_regular_26 green"
                textAlign={"center"}
              >
                Internal Disbursement
              </Typography>
            </Grid>

            {/* Disbursement Name Field Section */}
            <Grid item xs={6}>
              <TextField
                className="inputTextField normal_normal_600_12_Manropee"
                label="Disbursement Name"
                placeholder="Disbursement Name"
                fullWidth
                required
                size="small"
                value={disbursementData?.name || ""}
                onChange={(e) =>
                  handleChangeFormFields(e?.target?.value, "name")
                }
                error={isError && !disbursementData?.name}
                helperText={
                  isError && !disbursementData?.name && VALIDATION_MSG.REQUIRED
                }
                InputLabelProps={{ shrink: true }}
                variant="standard"
              />
            </Grid>

            {/* Is Commission Applicable? section */}
            <Grid item xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: "#00CE3F",
                      "&.Mui-checked": {
                        color: "#00CE3F",
                      },
                    }}
                    checked={disbursementData?.isActive || false}
                    onChange={(e) =>
                      handleChangeFormFields(e?.target?.checked, "isActive")
                    }
                  />
                }
                label="Is Active?"
              />
            </Grid>

            {/* Submit Button */}
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                className="save_button"
                onClick={handleCreateDisbursement}
              >
                Create
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateDisbursement;
